/**
 * lesson-plans/new.tsx — Create a new lesson plan.
 *
 * Renders the LessonPlanBuilder in create mode. After the tutor saves
 * the plan (and draft items), they are redirected to /lesson-plans/$id
 * to continue editing the newly created plan.
 */

import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { LessonPlanBuilder } from '../../components/lessons/LessonPlanBuilder.js';
import { freshSessionQuery } from '../../lib/api/queries.js';

export const Route = createFileRoute('/lesson-plans/new')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role !== 'tutor' || !user.isApprovedTutor) {
      throw redirect({ to: '/me' });
    }
    return null;
  },
  component: NewLessonPlanPage,
});

function NewLessonPlanPage() {
  const navigate = useNavigate();
  return (
    <LessonPlanBuilder
      initial={{}}
      onSaved={({ id }) => {
        void navigate({ to: '/lesson-plans/$id', params: { id } });
      }}
    />
  );
}